var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"sd-404-page pt-3"},[_c('b-row',[_c('b-col',{attrs:{"cols":"","md":"12"}},[_c('h1',[_vm._v("Page Not Found")]),_vm._v(" "),_c('p',[_vm._v("There is no page at this URL.")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{name:'dashboard'}}},[_vm._v("Return to Dashboard")])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }